import { fetchOpenF1Json } from "../config/openf1";
import { buildF1nsightApiUrl } from "./client";

export const fetchRaceMeetingKeys = async (selectedYear) => {
  try {
    const raceResponse = await fetch(buildF1nsightApiUrl("/races/races.json"));
    if (!raceResponse.ok) {
      throw new Error("Failed to fetch races");
    }
    const races = await raceResponse.json();
    return races[selectedYear];
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export const fetchRacesAndSessions = async (selectedYear) => {
  try {
    const racesData = await fetchOpenF1Json("/meetings", { year: selectedYear });
    const sessionsData = await fetchOpenF1Json("/sessions", {
      year: selectedYear,
      session_name: "Race",
    });

    return racesData.filter(race =>
      sessionsData.some(session => session.meeting_key === race.meeting_key)
    );
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const fetchRaceResults = async (selectedYear, raceId) => {
  const resultsUrl = buildF1nsightApiUrl(`/races/${selectedYear}/results.json`);
  try {
    const response = await fetch(resultsUrl);
    if (response.ok) {
      const tempdata = await response.json();
      const raceData = tempdata.find(element => element.round === raceId);
      if (!raceData?.Results) return [];

      return raceData.Results.slice(0, 3).map(result => ({
        driver: result.Driver,
        fastestLap: result.FastestLap,
        grid: result.grid,
        position: result.position,
        time: result.Time?.time || "N/A",
        status: result.status,
        number: result.number,
      }));
    }
  } catch (error) {
    console.error("Error fetching race results:", error);
  }
  return [];
};

export const fetchRaceDetails = async (selectedYear) => {
  const url = buildF1nsightApiUrl(`/races/${selectedYear}/raceDetails.json`);
  try {
    const response = await fetch(url);
    if (response.ok) {
      const races = await response.json();
      const raceResultsPromises = races.map(race => {
        if (new Date(race.date) < new Date()) {
          return fetchRaceResults(selectedYear, race.round)
            .then(results => ({
              ...race,
              results,
            }));
        }

        return Promise.resolve({
          raceName: race.raceName,
          date: race.date,
          season: race.season,
          round: race.round,
          time: race.time,
        });
      });

      return Promise.all(raceResultsPromises);
    }
    console.error("Failed to fetch data");
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  return [];
};

export const fetchUpcomingRace = async (selectedYear) => {
  const races = await fetchRaceDetails(selectedYear);
  const upcomingRace = races.find(race => new Date(race.date) > new Date());
  return upcomingRace || null;
};

export const fetchMostRecentRace = async (selectedYear) => {
  try {
    const raceDetailsResponse = await fetch(buildF1nsightApiUrl(`/races/${selectedYear}/raceDetails.json`));
    if (!raceDetailsResponse.ok) {
      throw new Error("Failed to fetch race details");
    }
    const raceDetails = await raceDetailsResponse.json();
    const meetingKeys = await fetchRaceMeetingKeys(selectedYear);
    const pastRaces = raceDetails.filter(race => new Date(race.date) <= new Date());
    const sortedRaces = pastRaces.sort((a, b) => new Date(b.date) - new Date(a.date));
    const mostRecentRace = sortedRaces[0];

    if (!mostRecentRace) {
      console.log("No past races available.");
      return null;
    }

    const meetingKey = meetingKeys[mostRecentRace.raceName]?.meeting_key || "unknown";
    const raceResults = await fetchRaceResults(selectedYear, mostRecentRace.round);

    return {
      ...mostRecentRace,
      meetingKey,
      raceResults,
    };
  } catch (error) {
    console.error("Error fetching race details:", error);
  }
  return null;
};
